export const submitEnquiry = async (formData) => {
    const API_URL_1 = "https://clients.dotphi.com/seo_html/insert1.php";
    const API_URL_2 = "https://www.emsys.solutions/contact.php";

    // Payload for first API
    const payload1 = new FormData();
    payload1.append('name', formData.name || "");
    payload1.append('email', formData.email || "");
    payload1.append('phone', formData.phone || "");
    payload1.append('subject', formData.subject || "Enquiry from Emsys Solutions Request Quote");
    payload1.append('message', formData.message || "NA");
    payload1.append('domain', "emsys.solutions");
    payload1.append('url', typeof window !== 'undefined' ? window.location.pathname : "/");
    payload1.append('project_unique_code', "emsys.solutions90");

    // Payload for second API
    const payload2 = new FormData();
    payload2.append('name', formData.name || "");
    payload2.append('email', formData.email || "");
    payload2.append('phone', formData.phone || "");
    payload2.append('subject', formData.subject || "Enquiry from Emsys Solutions Request Quote");
    payload2.append('message', formData.message || "NA");

    try {
        await Promise.all([
            // API 1: Requires FormData
            fetch(API_URL_1, {
                method: 'POST',
                body: payload1,
                mode: 'no-cors',
            }),
            // API 2: Requires JSON
            fetch(API_URL_2, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: formData.name || "",
                    email: formData.email || "",
                    phone: formData.phone || "",
                    subject: formData.subject || "Enquiry from Emsys Solutions Request Quote",
                    message: formData.message || "NA"
                }),
                mode: 'no-cors',
            })
        ]);

        return { success: true };
    } catch (error) {
        console.error("Form submission error:", error);
        return { success: false, error };
    }
};
